export default __webpack_public_path__ + "static/media/info.f0038c84.svg";